import { ApiClientBase } from '../base/api-client-base.ts';
import Endpoints from '../endpoints';
import type {
  IChatApi,
  CreateSessionParams,
  CreateSessionResponse,
  SendMessageParams,
  SendMessageResponse,
  GetMessagesParams,
  GetMessagesResponse,
  GetHistoryParams,
  GetHistoryResponse,
  UpdateSessionParams,
  UpdateSessionResponse,
  DeleteSessionParams,
  DeleteSessionResponse,
} from './chat.types';

export class ChatApi extends ApiClientBase implements IChatApi {
  public readonly createSession = async (
    params: CreateSessionParams
  ): Promise<CreateSessionResponse['data']> => {
    const url = Endpoints.Chat.createSession();
    const response = await this.asyncRunner(() =>
      this.api.post<CreateSessionResponse>(url, params)
    );
    return response.data.data;
  };

  public readonly sendMessage = async (
    params: SendMessageParams
  ): Promise<SendMessageResponse['data']> => {
    const url = Endpoints.Chat.sendMessage();
    const response = await this.asyncRunner(() =>
      this.api.post<SendMessageResponse>(url, params)
    );
    return response.data.data;
  };

  public readonly getMessages = async (
    params: GetMessagesParams
  ): Promise<GetMessagesResponse['data']> => {
    const url = Endpoints.Chat.getMessages(params.sessionId);
    const response = await this.asyncRunner(() =>
      this.api.get<GetMessagesResponse>(url, { params })
    );
    return response.data.data;
  };

  public readonly getHistory = async (
    params?: GetHistoryParams
  ): Promise<GetHistoryResponse['data']> => {
    const url = Endpoints.Chat.getHistory();
    const response = await this.asyncRunner(() =>
      this.api.get<GetHistoryResponse>(url, { params })
    );
    return response.data.data;
  };

  public readonly updateSession = async (
    params: UpdateSessionParams
  ): Promise<UpdateSessionResponse['data']> => {
    const url = Endpoints.Chat.updateSession(params.sessionId);
    const response = await this.asyncRunner(() =>
      this.api.patch<UpdateSessionResponse>(url, { title: params.title })
    );
    return response.data.data;
  };

  public readonly deleteSession = async (
    params: DeleteSessionParams
  ): Promise<DeleteSessionResponse['data']> => {
    const url = Endpoints.Chat.deleteSession(params.sessionId);
    const response = await this.asyncRunner(() =>
      this.api.delete<DeleteSessionResponse>(url)
    );
    return response.data.data;
  };
}
